import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { RateLimitService } from '../../services/rate-limit.service';

interface IaddRateLimitProfileContext {
  title: string;
  data: any;
}

@Component({
  selector: 'app-add-rate-limit-profile',
  templateUrl: './add-rate-limit-profile-settings.component.html',
  styleUrls: ['./add-rate-limit-profile-settings.component.scss'],
})
export class AddRateLimitProfileModalComponent {
  rateLimitForm!: FormGroup;
  pending: boolean;
  success: string;
  error: string;

  constructor(
    public modal: SuiModal<IaddRateLimitProfileContext, any, any>,
    private fb: FormBuilder,
    private rateLimitService: RateLimitService
  ) {
    this.rateLimitForm = fb.group({
      profileName: ['', Validators.required],
      requests: ['', Validators.required],
      timeInterval: ['', Validators.required],
      response: ['', Validators.required],
    });

    if (modal.context.data.operation === 'edit') {
      // this.rateLimitForm.patchValue({
      //     profileName: '',
      //     requests: '',
      //     timeInterval: '',
      //     response: ['']
      // })
    }
  }

  add() {
    this.pending = true;
    let body = {
      profileName: this.rateLimitForm.value.profileName,
      responseMessage: this.rateLimitForm.value.response,
      quota: Number(this.rateLimitForm.value.requests),
      interval: Number(this.rateLimitForm.value.timeInterval),
    };
    this.rateLimitService.addRateLimitProfile(body).subscribe(
      (res) => {
        this.pending = false;
        setTimeout(() => {
          this.modal.approve(undefined);
        }, 1500);
      },
      (error) => {
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error.message
          ? error.message
          : error;
        this.pending = false;
      }
    );
  }
}

export class AddRateLimitProfileModal extends ComponentModalConfig<
  IaddRateLimitProfileContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Mini) {
    super(AddRateLimitProfileModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
